enum CampaignVehicleLevel {
    None = 0,
    Manufacturer = 1,
    Range = 2
}

export default CampaignVehicleLevel;
